import { render, staticRenderFns } from "./CaseTime.vue?vue&type=template&id=4a5ce382&scoped=true"
import script from "./CaseTime.vue?vue&type=script&lang=js"
export * from "./CaseTime.vue?vue&type=script&lang=js"
import style0 from "./CaseTime.vue?vue&type=style&index=0&id=4a5ce382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5ce382",
  null
  
)

export default component.exports